<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8">
      <!-- Mask -->
      <span class="mask opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 mt-0 mt-md-4 mt-lg-0 d-block">
            <router-link
              :to="'/colaborador/pesquisas'"
              class="btn-link font-weight-normal text-white"
              title="Voltar para a listagem de pesquisas"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar
            </router-link>
          </div>
          <div class="col-lg-7 col-md-10">
            <p class="text-white my-3">
              Aqui você pode gerênciar e atualizar as informações da pesquisa de
              satisfação. Lembre-se de ficar atento a modificações que podem
              comprometer a visualização de possíveis respostas para as
              perguntas.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-xl-8 mb-4">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-12">
                  <h3 class="mb-0">
                    <i class="fas fa-list-alt mr-2"></i> Responder pesquisa de
                    satisfação -
                    <span class="text-warning">{{ versaoPesquisa.title }}</span>
                    <base-button
                      size="sm"
                      type="danger"
                      class="float-right"
                      @click="handleOpenModalRemove()"
                      v-if="!empty"
                    >
                      <i class="fas fa-trash mr-1"></i> Excluir resposta
                    </base-button>
                  </h3>
                </div>
              </div>
            </div>
            <div class="vld-parent" ref="form_container">
              <template>
                <form role="form">
                  <div class="text-center mb-4">
                    <badge
                      v-tooltip.bottom="'Período em que a pesquisa está ativa'"
                      type="primary"
                    >
                      Pesquisa disponível de
                      {{ formatDate(versaoPesquisa.start_date) }} até
                      {{ formatDate(versaoPesquisa.end_date) }}
                    </badge>
                  </div>
                  <hr class="my-4" />
                  <div class="row ml-1">
                    <h6 class="heading-small text-muted mb-4">
                      Informações da pesquisa
                    </h6>
                  </div>
                  <div class="row ml-lg-2">
                    <div class="col-lg-12 mb-4">
                      <label class="form-control-label">{{
                        versaoPesquisa.objective_question
                      }}</label>
                      <p class="description">
                        Selecionado:
                        <span class="font-weight-bold">{{
                          model.objective_answer
                        }}</span>
                      </p>
                      <enps-range
                        :disabled="false"
                        v-model="model.objective_answer"
                      />
                    </div>
                    <div class="col-lg-12">
                      <hr class="my-4" />
                      <label class="form-control-label">{{
                        versaoPesquisa.descriptive_question
                      }}</label>
                      <textarea
                        rows="3"
                        v-model="model.descriptive_answer"
                        class="form-control"
                        placeholder="Escreva sua resposta aqui..."
                      >
                      </textarea>
                    </div>
                  </div>
                  <div class="row ml-2" v-if="error">
                    <div class="col-lg-12 text-center">
                      <base-alert type="danger">{{ error }}</base-alert>
                    </div>
                  </div>
                  <div class="text-right">
                    <base-button
                      type="primary"
                      class="mt-4"
                      :custom="true"
                      @click="handleSubmit()"
                      :disabled="!isValidModel"
                      >Salvar resposta</base-button
                    >
                  </div>
                </form>
              </template>
            </div>
          </card>
        </div>
      </div>
    </div>
    <modal
      :show.sync="modalRemove.show"
      modal-classes="modal-default modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="vld-parent" ref="modal_confirmation_delete">
        <div class="pb-3 pt-0 text-center">
          <i class="fa fa-exclamation-circle fa-3x"></i>
          <h4 class="heading mt-4">
            Você realmente deseja
            <span class="text-danger"
              >excluir sua resposta à pesquisa de satisfação</span
            >?
          </h4>
          <p class="mt-3 mb-0">
            Ao confirmar, a resposta à pesquisa
            <span class="font-weight-bold">{{ versaoPesquisa.title }}</span>
            será removida.
          </p>
        </div>
        <div class="col-12 text-center mt-3" v-if="modalRemove.error">
          <base-alert type="danger"
            >Ocorreu um erro ao remover a resposta. Tente novamente.</base-alert
          >
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="l-auto"
          @click="modalRemove.show = false"
        >
          Voltar
        </base-button>
        <base-button
          type="white"
          class="text-danger"
          @click="handleRemoveAnswer()"
        >
          Confirmar exclusão
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api.js";
import EnpsRange from "@/components/EnpsRange.vue";

export default {
  name: "pesquisas_edit",
  components: {
    EnpsRange
  },
  data() {
    return {
      model: {
        id: null,
        objective_answer: 5,
        descriptive_answer: ""
      },
      versaoPesquisa: "",
      error: "",
      empty: false,
      modalRemove: {
        show: false,
        error: ""
      }
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.form_container,
      width: 90,
      height: 90
    });
    try {
      await this.loadPesquisa();
      const { data } = await api.get(
        `/collaborator/satisfaction-survey/answer/${this.$route.params.id}`
      );
      if (data[0]) {
        this.model = data[0];
      } else this.empty = true;
      loader.hide();
    } catch (e) {
      this.$toasted.error(
        "Ocorreu um erro ao recuperar as informações da pesquisa"
      );
    }
  },
  methods: {
    async loadPesquisa() {
      const loader = this.$loading.show({
        container: this.$refs.form_container,
        width: 90,
        height: 90
      });
      try {
        const { data } = await api.get(
          `/collaborator/satisfaction-survey/${this.$route.params.id}`
        );
        this.versaoPesquisa = data;
        loader.hide();
      } catch (e) {
        this.$toasted.error(
          "Ocorreu um erro ao recuperar as informações da pesquisa"
        );
      }
    },
    async handleSubmit() {
      this.error = "";
      const loader = this.$loading.show({
        container: this.$refs.form_container,
        width: 90,
        height: 90
      });
      try {
        if (this.empty) {
          await api.post(
            `/collaborator/satisfaction-survey/answer/${this.$route.params.id}`,
            this.model
          );
          this.$toasted.show("Resposta enviada com sucesso");
          this.empty = false;
        } else {
          await api.put(
            `/collaborator/satisfaction-survey/answer/${this.model.id}`,
            this.model
          );
          this.$toasted.show("Resposta salva com sucesso");
        }
      } catch (e) {
        const genericError =
          "Ocorreu um erro ao salvar a sua resposta. Tente novamente.";
        const hasErrorResponseData = e.response && e.response.data;
        let customError = genericError;
        if (hasErrorResponseData) {
          const data = e.response.data.error
            ? e.response.data.error
            : e.response.data.errors;
          if (data[0] && data[0].message) customError = data[0].message;
          else if (data.message) customError = data.message;
        }
        this.error = hasErrorResponseData ? customError : genericError;
        this.$toasted.error("Ocorreu um erro ao salvar as informações");
      }
      loader.hide();
    },
    handleOpenModalRemove() {
      this.modalRemove.error = "";
      this.modalRemove.show = true;
    },
    async handleRemoveAnswer() {
      this.modalRemove.error = false;
      const loader = this.$loading.show({
        container: this.$refs.modal_confirmation_delete,
        width: 160,
        height: 160,
        opacity: 0
      });
      try {
        await api.delete(
          `/collaborator/satisfaction-survey/answer/${this.model.id}`
        );
        this.$toasted.show("Pesquisa removida com sucesso");
        this.model = {
          id: null,
          objective_answer: 5,
          descriptive_answer: ""
        };
        this.empty = true;
        this.modalRemove.show = false;
      } catch (e) {
        this.$toasted.error(
          "Ocorreu um erro ao remover a pesquisa de satisfação"
        );
        this.modalRemove.error = true;
      } finally {
        loader.hide();
      }
    }
  },
  computed: {
    isValidModel() {
      return this.model.objective_answer && this.model.descriptive_answer;
    }
  },
  watch: {
    "model.objective_answer": function() {
      this.model.objective_answer = parseInt(this.model.objective_answer);
    }
  }
};
</script>
<style>
.categories_select.v-select {
  background-color: #fff;
  background-clip: padding-box;
}
.categories_select.v-select .vs__dropdown-toggle {
  padding: 0.5rem 0.1rem;
  min-width: 100%;
}
.categories_select.v-select
  .vs__dropdown-toggle
  .vs__selected-options
  .vs__search {
  color: #8898aa;
  font-weight: 400;
  line-height: 1.5;
  font-size: 0.875rem;
}
</style>
